import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "./GalleryDisplay.css";

// const BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
const BASE_URL = "https://atlastravelhouse.com";

const GalleryDisplay = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/packages/`)
      .then((res) => {
        const allImages = res.data.flatMap((pkg) => pkg.gallery_images);
        setGalleryImages(allImages);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching gallery images:", err);
        setLoading(false);
      });
  }, []);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  if (loading) return <p>Loading gallery...</p>;
  if (galleryImages.length === 0) return <p>No images found.</p>;

  return (
    <div className="gallery-slider-wrapperr">
      <button className="arrow l" onClick={scrollLeft}>
        &lt;
      </button>
      <div className="gallery-sliderr" ref={scrollRef}>
        {galleryImages.map((img) => (
          <div key={img.id} className="gallery-slide">
            <img 
              src={
                img.image
                  ? img.image.startsWith("http://")
                    ? img.image.replace("http://", "https://")
                    : img.image.startsWith("https://")
                      ? img.image
                      : `${BASE_URL}${img.image}`
                  : ""
              } 
              alt={img.title || "Gallery"} 
            />

          </div>
        ))}
      </div>
      <button className="arrow r" onClick={scrollRight}>
        &gt;
      </button>
    </div>
  );
};

export default GalleryDisplay;
